<template>
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">

            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              :placeholder="$t('Search')"
            />
          </div>
        </b-col>
      </b-row>
    </div>
    <b-table
      ref="applyDocumentTable"
      :items="applyDocuments"
      responsive
      :fields="tableColumns"
      primary-key="id"
      show-empty
      :empty-text="$t('No matching records found')"
      class="position-relative"
    >
      <template #head()="data">
        {{ $t(data.label) }}
      </template>

      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template #cell(dc_type)="data">
        {{ $langName(getDcType(data.value).name) }}
      </template>

      <template #cell(user)="data">
        {{ data.value.full_name }}
      </template>

      <template #cell(edu_lang)="data">
        {{ $langName(getEduLang(data.value).name) }}
      </template>

      <template #cell(quarter)="data">
        {{ data.value.period.admission_year + '/' +data.value.quarter }}
      </template>

      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            variant="primary"
            label=""
          />
        </div>
      </template>

      <template #cell(status)="data">
        <b-badge :variant="getApplyDocumentStatusColor(data.value)">
          {{ $langName(getApplyDocumentStatus(data.value).name) }}
        </b-badge>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">

        <div class="text-nowrap">
          <feather-icon
            icon="EyeIcon"
            class="cursor-pointer mr-1"
            size="16"
            @click="$router.push({ name: 'applicant-document-view', params: { id: data.item.id }})"
          />
          <feather-icon
            v-b-toggle.sidebar-change-apply-document
            icon="PlusSquareIcon"
            class="cursor-pointer mr-1"
            size="16"
            @click="selectApplyDoc(data.item)"
          />
        </div>
      </template>

    </b-table>
  </b-card>
</template>
<script>
import { ref } from '@vue/composition-api'
import {
  BCard, BCol, BFormInput, BRow, BSpinner, BTable, VBToggle, BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'ApplyDocumentComponent',
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BCard, BCol, BFormInput, BRow, BSpinner, BTable, BBadge,
  },
  props: {
    applyDocuments: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getDcType(id) {
      return this.$store.getters['staticModule/getDcType'](id)
    },
    getEduLang(id) {
      return this.$store.getters['staticModule/getEduLangType'](id)
    },
    getApplyDocumentStatus(id) {
      return this.$store.getters['staticModule/getApplyDocumentStatus'](id)
    },
    getApplyDocumentStatusColor(id) {
      return this.$store.getters['staticModule/getApplyDocumentStatusColor'](id)
    },
    selectApplyDoc(data) {
      this.$emit('selectApplyDoc', data)
    },
  },
  setup() {
    const tableColumns = [
      { key: 'index', label: '#' },
      { key: 'user', label: 'Applicant', sortable: true },
      { key: 'dc_type', label: 'Dc Type', sortable: true },
      { key: 'edu_lang', label: 'Education Language', sortable: true },
      { key: 'status', label: 'Status', sortable: true },
      { key: 'actions', label: 'Actions' },
    ]
    const searchQuery = ref('')
    return {
      tableColumns,
      searchQuery,
    }
  },
}
</script>
